import React, { Component } from 'react';
import moment from 'moment';

import DriveEtaRoundedIcon from '@material-ui/icons/DriveEtaRounded';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Loading from '../Loading.jsx';
import Button from '../../bits/Button.jsx';
import { customFetchV2 } from '../../../services/custom-fetch-v2.ts';

const ListContent = styled.div`
  margin-bottom: 30px;
`;

const StyledButton = styled(Button)`
  max-width: 600px;
`;

const ListActions = styled.div`
  display: flex;
  justify-content: center;
`;

const EVENT_NAME_MAPPINGS = {
  trip_started: 'Trip Started',
  trip_ended: 'Trip Ended',
  sos: 'SOS Alert',
  nmd_movement: 'Movement Detected',
  nmd_non_movement: 'No Movement Detected',
  power_connected: 'Power Connected',
  power_disconnected: 'Power Disconnected',
  harsh_driving: 'Harsh Driving',
  low_battery: 'Low Battery',
  speeding: 'Speeding',
  location_locked: 'Location Lock Enabled',
  location_unlocked: 'Location Lock Disabled',
  location_lock_broken: 'Location Lock Broken',
  ignition_on: 'Ignition On',
  ignition_off: 'Ignition Off',
  tamper: 'Device Tampering Detected',
};

class DeviceActivityList extends Component {
  state = {
    isLoading: true,
    events: [],
  };

  componentDidMount() {
    // We probably also want to do this if we detect the deviceFilter prop has changed
    this.loadEvents();
  }

  loadEvents = (nextCursor) => {
    const { deviceId } = this.props;

    this.setState({ isLoading: true });

    let url = `/api/v2/devices/${deviceId}/events?`;
    if (nextCursor) {
      url += `&next=${nextCursor}`;
    }

    return customFetchV2(url, {
      method: 'GET',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Ooops');
        }

        return response.data;
      })
      .then((json) => {
        const events = nextCursor ? this.state.events.concat(json.results) : json.results;

        this.setState({
          events,
          nextCursor: json.nextCursor,
          isLoading: false,
        });
      })
      .catch((e) => {
        this.setState({ isLoading: false });

        throw e;
      });
  };

  renderNoEvents = () => {
    if (this.state.isLoading) {
      return (
        <div className="section">
          <Loading />
        </div>
      );
    }

    return (
      <div style={{ textAlign: 'center', fontSize: '0.8em' }}>
        <div style={{ fontSize: '100px' }}>
          <DriveEtaRoundedIcon fontSize="inherit" />
        </div>
        <p>
          No device activity detected yet.
        </p>
      </div>
    );
  }

  eventName = event => EVENT_NAME_MAPPINGS[event.event_type] || 'Unknown Event';

  eventTimeLabel = (event) => {
    const label = moment(event.event_at).format('dddd, MMMM Do @ h:mm A');
    return label;
  };

  renderEventPanels = () => this.state.events.map((event, ix) => (
    <div key={ix} style={{ margin: '15px' }}>
      <p><strong>{this.eventName(event)}</strong></p>
      <p>{this.eventTimeLabel(event)}</p>
    </div>
  ));

  renderEventContent = () => (
    <React.Fragment>
      <div style={{ marginBottom: '20px' }}>
        {this.renderEventPanels()}
      </div>
    </React.Fragment>
  );

  hasEvents = () => this.state.events && this.state.events.length > 0;

  loadNext = () => {
    this.loadEvents(this.state.nextCursor);
  }

  render() {
    return (
      <>
        <ListContent>
          { this.hasEvents() ? this.renderEventContent() : this.renderNoEvents() }
        </ListContent>
        <ListActions>
          <StyledButton
            onClick={this.loadNext}
            color="secondary"
            disabled={!this.state.nextCursor}
            loading={this.state.isLoading}>
            Load more
          </StyledButton>
        </ListActions>
      </>
    );
  }
}

DeviceActivityList.propTypes = {
  deviceId: PropTypes.string.isRequired,
};


export default DeviceActivityList;
